import { useState } from 'react'
import { Check, Sparkles, X, Zap, Star, Building2, ArrowRight } from 'lucide-react'
import { PLANS } from '../data/pricing'
import { formatCurrency } from '../lib/format'

const ICONS = { Zap, Star, Building2 }

export default function UpgradeModal({ open, onClose, onUpgrade, currentPlan }) {
  const [selected, setSelected] = useState(null)

  if (!open) return null

  const handleUpgrade = (tierId) => {
    setSelected(tierId)
    onUpgrade?.(tierId)
    setTimeout(() => {
      setSelected(null)
      onClose?.()
    }, 700)
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4 py-8">
      <div className="absolute inset-0 bg-ink/40" onClick={onClose} aria-hidden />
      <div className="relative bg-surface border border-neutral-200 w-full max-w-4xl animate-fade-in">
        <div className="flex items-center justify-between px-7 py-5 border-b border-neutral-200">
          <div className="flex items-center gap-2.5">
            <Sparkles size={18} className="text-brand" />
            <div>
              <h2 className="text-base font-semibold text-ink">Upgrade your plan</h2>
              <p className="text-xs text-muted mt-0.5">Unlock more document categories, staff seats, and premium features.</p>
            </div>
          </div>
          <button onClick={onClose} className="text-neutral-400 hover:text-ink" aria-label="Close">
            <X size={18} />
          </button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-px bg-neutral-200">
          {PLANS.map((tier) => {
            const isPopular = tier.highlighted
            const isCurrent = tier.id === currentPlan
            const Icon = ICONS[tier.icon]
            return (
              <div
                key={tier.id}
                className={`bg-surface p-6 flex flex-col ${isPopular ? 'relative' : ''}`}
              >
                {isPopular && (
                  <span className="absolute top-4 right-4 inline-flex items-center gap-1 px-2 py-0.5 bg-brand text-white text-[10px] font-semibold uppercase tracking-wide">
                    <Sparkles size={10} /> Most Popular
                  </span>
                )}
                <div className="flex items-center gap-2 mb-1">
                  {Icon && <Icon size={16} className="text-brand" />}
                  <h3 className="text-sm font-semibold text-ink">{tier.name}</h3>
                </div>
                <p className="text-xs text-muted mt-1">{tier.tagline}</p>
                <div className="mt-4 mb-5">
                  <span className="text-3xl font-bold text-ink">{formatCurrency(tier.price, 'NGN')}</span>
                  <span className="text-xs text-muted ml-1">/mo</span>
                </div>
                <ul className="space-y-2.5 mb-6 flex-1">
                  {tier.features.map((f) => (
                    <li key={f} className="flex items-start gap-2 text-xs text-ink">
                      <Check size={13} className="text-brand mt-0.5 shrink-0" />
                      {f}
                    </li>
                  ))}
                </ul>
                <button
                  onClick={() => handleUpgrade(tier.id)}
                  className={isPopular ? 'btn-primary text-xs' : 'btn-secondary text-xs'}
                  disabled={selected !== null || isCurrent}
                >
                  {isCurrent ? 'Current Plan' : selected === tier.id ? 'Upgrading…' : `Upgrade to ${tier.name}`}
                </button>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
